webpackJsonp([7040292994530],{

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(17);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _components = __webpack_require__(8);
	
	var _data = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'A corporation is a company or group of people or an organisation authorized to act as a single entity (legally a person) and recognized as such in law.'
	    )
	  );
	};
	
	var fieldSets = [{
	  legend: 'Corporation Information',
	  fields: new Map([['orgName', {
	    label: 'Corporation Name',
	    title: 'Please provide a valid corporation name',
	    'data-help-title': 'Corporation Name',
	    'data-help-text': 'Please enter the name of the corporation.',
	    validation: Yup.string().required('Please provide a valid corporation name')
	  }], ['dba', {
	    'data-help-text': 'Please enter the trade name of the corporation.'
	  }]])
	}, {
	  legend: 'Primary Officer Information',
	  fields: new Map([['firstName', {
	    'data-help-title': 'Principal Officer',
	    'data-help-text': 'Principal/Highest ranking officer.'
	  }], ['middleName', {
	    'data-help-title': 'Principal Officer',
	    'data-help-text': 'Principal/Highest ranking officer.'
	  }], ['lastName', {
	    'data-help-title': 'Principal Officer',
	    'data-help-text': 'Principal/Highest ranking officer.'
	  }], ['socialSecurity', {
	    'data-help-title': 'Principal Officer',
	    'data-help-text': 'Principal/Highest ranking officer.'
	  }], ['verifySocialSecurity', {
	    'data-help-title': 'Principal Officer',
	    'data-help-text': 'Principal/Highest ranking officer.'
	  }], ['title', {
	    label: 'Business Title',
	    placeholder: 'Mangaing Member',
	    'data-help-title': 'Mangaing Member',
	    'data-help-text': 'Principal/Highest ranking officer.'
	  }], ['suffix', {
	    initial: 'DDS'
	  }]])
	}, {
	  legend: 'Business Address',
	  fields: new Map([['businessAddress'], ['businessCity'], ['businessState'], ['businessZip'], ['businessCounty'], ['mailingAddressDiff']])
	}, {
	  legend: 'Business Information',
	  fields: new Map([['businessIncCountry', {
	    label: 'Where was the LLC organized?'
	  }], ['businessApplyReason'], ['businessActivity'], ['businessServices'], ['commonQuestionOne'], ['commonQuestionTwo'], ['commonQuestionThree'], ['commonQuestionFour'], ['businessAppliedBefore'], ['businessHireEmployees']])
	}, {
	  legend: 'Business Dates',
	  fields: new Map([['businessDateStart'], ['businessClosingMonth']])
	}, {
	  legend: 'Contact Information',
	  fields: new Map([['customerContactPhone'], ['customerContactEmail'], ['customerContactEmailVerify', {
	    label: 'Verify Contact E-mail'
	  }]])
	}];
	
	var CorporationApplicationPage = function CorporationApplicationPage(props) {
	  return _react2.default.createElement(_components.ApplicationFlow, _extends({
	    step: 2,
	    title: 'Corporation Application',
	    documentType: _data.documentTypes.CORPORATION,
	    description: Description,
	    fieldSets: fieldSets
	  }, props));
	};
	
	exports.default = CorporationApplicationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-corporation-application-js-902d77a8080fa5a46fe2.js